import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";
const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getAllActionItemsList(
  oauthTokenHeader: string,
  selectedSharedUid: string
) {
  return fetchWrapper.get(
    `${apiUrl}/utilities/tasks/?type=Action Items&reference_id=${selectedSharedUid}`,
    oauthTokenHeader
  );
}
function updateActionTaskStatus(oauthTokenHeader: any, data: any) {
  return fetchWrapper.patch(
    `${apiUrl}/utilities/tasks/`,
    data,
    oauthTokenHeader
  );
}

function postComment(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: any
) {
  return fetchWrapper.post(
    `${apiUrl}/utilities/comments/${object_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function getComments(oauthTokenHeader: string, object_shared_uid: any) {
  return fetchWrapper.get(
    `${apiUrl}/utilities/comments/${object_shared_uid}/`,
    oauthTokenHeader
  );
}

function getAllUsers(oauthTokenHeader: any) {
  return fetchWrapper.get(
    `${apiUrl}/admin/users/?active_only=True/`,
    oauthTokenHeader
  );
}

function getAllWebsites(oauthTokenHeader: any) {
  return fetchWrapper.get(
    `${apiUrl}/asset_management/websites/`,
    oauthTokenHeader
  );
}

function createActionItem(oauthTokenHeader: string, data: any) {
  return fetchWrapper.post(
    `${apiUrl}/utilities/tasks/`,
    data,
    oauthTokenHeader
  );
}

function fileUploadItem(
  oauthTokenHeader: string,
  data: any,
  object_shared_uid: any
) {
  return fetchWrapper.post(
    `${apiUrl}/utilities/file/${object_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function getFilesItem(oauthTokenHeader: string, object_shared_uid: any) {
  return fetchWrapper.get(
    `${apiUrl}/utilities/file/${object_shared_uid}/`,
    oauthTokenHeader
  );
}

function getSingleActionItem(
  oauthTokenHeader: string,
  action_item_shared_uid: string
) {
  return fetchWrapper.get(
    `${apiUrl}/utilities/tasks/${action_item_shared_uid}/`,
    oauthTokenHeader
  );
}

function updateActionTaskData(
  oauthTokenHeader: any,
  data: any,
  action_item_shared_uid: string
) {
  return fetchWrapper.patch(
    `${apiUrl}/utilities/tasks/${action_item_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function putComments(oauthTokenHeader: string, data: any, object_shared_uid: any) {
  return fetchWrapper.put(
    `${apiUrl}/utilities/comments/${object_shared_uid}/`,
    data,
    oauthTokenHeader
  );
}

function deleteComment(oauthTokenHeader: string, object_shared_uid: any, comment_shared_uid: any) {
  return fetchWrapper.delete(`${apiUrl}/utilities/comments/${object_shared_uid}/?comment=${comment_shared_uid}`, oauthTokenHeader);
}

function deleteFile(oauthTokenHeader: string, file_shared_uid: any) {
  return fetchWrapper.delete(`${apiUrl}/utilities/file/${file_shared_uid}/`, oauthTokenHeader);
}

export const actionItemsService = {
  getAllActionItemsList,
  updateActionTaskStatus,
  postComment,
  getComments,
  getAllUsers,
  getAllWebsites,
  createActionItem,
  fileUploadItem,
  getFilesItem,
  getSingleActionItem,
  updateActionTaskData,
  putComments,
  deleteComment,
  deleteFile
};
